// Kai'Sa — Killer Instinct: fires a purple rocket salvo (4 rockets each) at up to 3 targets.

import { hexDistance } from "../../engine/hex/HexCoord";
import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Unit } from "../Unit";
import type { Ability, AbilityContext, AbilityHit } from "./Ability";

// Timing constants (ms) — kept in sync with KaisaVFX.
export const KAISA_WINDUP_MS         = 160;
export const KAISA_ROCKET_STAGGER_MS = 90;
export const KAISA_TARGET_STAGGER_MS = 420;
export const KAISA_ROCKET_TRAVEL_MS  = 170;

const ROCKETS_PER_TARGET = 4;
const MAX_TARGETS = 3;

function pickTargets(ctx: AbilityContext, count: number): Unit[] {
  const enemies = ctx.combat.livingUnitsOf(
    ctx.caster.team === "player" ? "enemy" : "player",
  );
  return enemies
    .filter((e) => e.currentHp > 0)
    .sort((a, b) => hexDistance(ctx.caster.pos, a.pos) - hexDistance(ctx.caster.pos, b.pos))
    .slice(0, count);
}

export const kaisaUlt: Ability = {
  id: "kaisaUlt",
  displayName: "Killer Instinct",
  description: "Fires 4 void rockets at each of 3 enemies.",
  iconId: "KaisaR",

  targetShape(ctx) {
    return pickTargets(ctx, MAX_TARGETS).map((t) => t.pos);
  },

  computeHits(ctx) {
    const targets = pickTargets(ctx, MAX_TARGETS);
    const stats = effectiveStats(ctx.caster);
    const starMult = ctx.caster.stars === 3 ? 20 : 1;
    const dmg = magicDamage((stats.ap * 1.3 + stats.ad * 0.4 + 70) * starMult);

    return targets.map((t, ti) => ({
      target: t,
      amount: dmg,
      type: "magical" as const,
      suppressPopup: true,
      kaisaRocket: true,
      delayMs:
        KAISA_WINDUP_MS +
        ti * KAISA_TARGET_STAGGER_MS +
        (ROCKETS_PER_TARGET - 1) * KAISA_ROCKET_STAGGER_MS +
        KAISA_ROCKET_TRAVEL_MS,
    })) satisfies AbilityHit[];
  },
};
